import React, { useState, useEffect} from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';

import { 
    Layout,
    Col, 
    Row,
    // Dropdown, 
    // Space,
    // Modal,
    Space,
} from 'antd';
import { 
  useNavigate,  
  useParams 
} from 'react-router-dom';
import {
  ArrowBack,
} from '@mui/icons-material';
// import { ExclamationCircleFilled } from '@ant-design/icons';
import { UseGetRequest } from '../../Utils/api/ApiRequests'

// const { confirm } = Modal;

const ParkingContractHistory = () => {
  const navigate = useNavigate()
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  // const [filterConfig, setFilterConfig] = useState({
  //   // user_id: '',
  //   tenant_id: id,
  // })
  const [historyData, setHistoryData] = useState([])

  async function fetchHistoryData() {
    setIsLoading(true);

    const response = await UseGetRequest("tenant_parkings/rate_history", {tenant_parking_id: id});
    if (response.data) {
      setHistoryData(response.data.data);
    } else {
      setHistoryData([])
    }

    setIsLoading(false);
  }

  useEffect(() => {
    fetchHistoryData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
      <Layout className='page'>
          <Navbar/>
          <Layout className='content-container'>
            <Row className='custom-padding responsive-inline responsive-tab-inline'>
              <Col span={24} className='header-container'>
                    <Space>
                        <ArrowBack className='cursor' onClick={() => navigate(-1)}/>
                        TENANT PARKING HISTORY
                    </Space>
                </Col>
            </Row>
            <Row className='page-content'>
              <Col span={24} className='responsive-overflow-auto'>
                <AntDTable
                  tableHeaders={[
                    "Description",
                    "Period Covered",
                    "Parking Rental Rate",
                    "Lease Term",
                    // "Escalation Year",
                    "Status",
                    "Updated On",
                    "Updated By",
                  ]}
                  headerSelector={[
                    "description",
                    "date_covered",
                    "parking_rental_rate",
                    "lease_term",
                    // "year",
                    "status",
                    "status_date",
                    "updated_by",
                  ]}

                  tableData={historyData}
                  withAction={false}
                  loading={isLoading}
                  // isClickable={true}
                  // rowClickPath={"/patients/profile"}
                  tablePages={10}
                  // handleTableChange={handleTableChange}
                  // filterConfig={filterConfig}
                  // totalSize={totalSize}
                  isSearch={true}
                />
              </Col>
            </Row>
          </Layout>
      </Layout>
  )
}

export default ParkingContractHistory
